import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, asyncScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requestCount = 0;
  private loading$ = new BehaviorSubject<boolean>(false);

  // observeOn(asyncScheduler) defers every emission to a fresh macrotask. This is what prevents
  // NG0100 (ExpressionChangedAfterItHasBeenCheckedError): requests started during change detection
  // (e.g. from ngOnInit/resolvers) flip the spinner outside the CD pass that read isLoading$.
  // Do not remove it.
  readonly isLoading$: Observable<boolean> = this.loading$.pipe(observeOn(asyncScheduler));

  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loading$.next(true);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
    if (this.requestCount === 0) {
      this.loading$.next(false);
    }
  }
}
